import { render, staticRenderFns } from "./loaded.vue?vue&type=template&id=4b654e02&scoped=true&"
import script from "./loaded.vue?vue&type=script&lang=js&"
export * from "./loaded.vue?vue&type=script&lang=js&"
import style0 from "./loaded.vue?vue&type=style&index=0&id=4b654e02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b654e02",
  null
  
)

export default component.exports